import request from '@/utils/Request'

export type MemberCardResponse = {
  user: {
    id: number
    scrambled_id: number
    zero_padding_scrambled_id: string
    point: number
    isProvisionalRegistration: boolean
    is_registered: boolean
    app_barcode_number: number
    rank: {
      id: number
      key: string
      name: string
    }
    point_expiring_this_month: number
    point_expires_on: Date
    provisional_point_expire_period_day: number,
    is_ec_united_user: boolean,
    extendable_point: number
  }
  barcode: string
  next_rank_necessary_amount: number
  next_month_rank_name: string
}

export async function memberCard() {
  return await request.get<MemberCardResponse>(`/member-card`)
}